import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Tree } from 'antd';

import { getDepartment } from 'actions/asyncActions';

const TreeNode = Tree.TreeNode;

@withAsyncActions({
    getDepartment: getDepartment
        .withPayload(props => ({
            company: props.id
        }))
        .withOptions({ dispatchOnMount: true, resetOnUnmount: true })
})
export default class CompanyStructure extends Component {
    makeDepartmentsTree = (data, item, offset = 0) => (
        data.filter(child => (!item && !child.parent_id) || (item && child.parent_id === item.id))
            .map(child => ({
                ...child,
                children: (
                    data.some(i => i.parent_id === child.id) ? (
                        this.makeDepartmentsTree(data, child, offset > 5 ? offset : offset + 1)
                    ) : []
                ),
                offset
            }))
    )

    renderTree = (data) => {
        return data.map((item) => {
            if (item.children.length > 0) {
                return (
                    <TreeNode className="company-departments-item" title={item.name} key={item.id} selectable={false}>
                        { this.renderTree(item.children) }
                    </TreeNode>
                )
            } else {
                return <TreeNode className="company-departments-item" title={item.name} key={item.id} selectable={false} />;
            }
        })
    }

    render() {
        const { getDepartment: { data: departmentList } } = this.props;
        const departmentTree = this.makeDepartmentsTree(departmentList);

        return (
            <div className="panel-view company-departments">
                <Tree className="company-departments-list">
                    { this.renderTree(departmentTree) }
                </Tree>
            </div>
        );
    }
}
